export enum CleanType {
    STANDARD = 'Standard',
    KITCHEN = 'Kitchen',
    BATHROOM = 'Bathroom',
}

export const CLEAN_TYPE_TRANSLATION_MAP = {
    [CleanType.STANDARD]: 'housekeeping_preferences_standard_title',
    [CleanType.BATHROOM]: 'housekeeping_preferences_bathroom_title',
    [CleanType.KITCHEN]: 'housekeeping_preferences_kitchen_title',
};
